<template lang="pug">
  .wrap(:style="`background-image: url(${baseUrl + bgimage})`")

</template>
<script>
export default {
  data () {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  props: {
    bgimage: String
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  height: 150vh;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  filter: grayscale(100);
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  &::after{
    content: '';
    background: linear-gradient(transparent, black);
    height: 30%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

</style>


